import { IZorroInsightData } from '../../models/zorro-insight-data.model';
import { InsightsService } from './../../services/insights/insights.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-insights-page',
  templateUrl: './insights-page.component.html',
  styleUrl: './insights-page.component.scss'
})
export class InsightsPageComponent {
  show = true;
  dailyMeter: IZorroInsightData = {
    columns: [],
    data: []
  };

  weeklyMeter: IZorroInsightData = {
    columns: [],
    data: []
  };

  colsDaily: number = 2;
  colsWeekly: number = 3;

  constructor(
    private insigthsService: InsightsService,
  ) {
    this.get();
  }

  async get() {
    const response = await this.insigthsService.get();
    this.dailyMeter = response.data!.dailyMeter;
    this.weeklyMeter = response.data!.weeklyMeter;
    this.colsDaily += this.dailyMeter.columns.length;
    this.colsWeekly += this.weeklyMeter.columns.length;
  }
}
